import React, {useContext} from 'react'
import {AppAdminContext} from '../../../app/AppAdminContext'
import {AdminDialogBase} from './AdminDialogBase'

import { DialogProps, Slide } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions/transition';

const UpTransition = React.forwardRef<unknown, TransitionProps>(
// @ts-ignore
    (props, ref) => <Slide direction="up" ref={ref} {...props} />,
)

export const AdminDialog = (props: DialogProps) => {
    const fullScreen = useContext(AppAdminContext).showSpModePage
    return <>
        <AdminDialogBase
            {...props}
            fullScreen={fullScreen}
            TransitionComponent={fullScreen ? UpTransition : undefined}
        />
    </>
}
